import React from 'react';
import { Box, Link, Grid } from '@mui/material'; // Updated imports for Material-UI v5
import { useIntl } from 'react-intl';
import styled from '@emotion/styled';

const StyledBox = styled(Box)`
  background-color: #dbdbdb;
  padding: 8px;
  & a {
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    color: black;
  }
`;

export default function GreyBox({ handleLinkClick }) {
  const { formatMessage } = useIntl();

  return (
    <StyledBox>
      <Grid container justifyContent="center">
        <Grid item xs={2} sx={{ textAlign: 'end' }}>
          <Link
            href="#"
            onClick={() =>
              handleLinkClick(
                formatMessage({ id: 'header.greyBox.eFleets.url' }),
                formatMessage({ id: 'header.greyBox.eFleets.text' }),
              )
            }
          >
            {formatMessage({ id: 'header.greyBox.eFleets.text' })}
          </Link>
        </Grid>
        <Grid item xs={2}>
          <Link
            href="#"
            onClick={() =>
              handleLinkClick(
                formatMessage({ id: 'header.greyBox.chargerRebates.url' }),
                formatMessage({ id: 'header.greyBox.chargerRebates.text' }),
                true,
              )
            }
          >
            {formatMessage({ id: 'header.greyBox.chargerRebates.text' })}
          </Link>
        </Grid>
        <Grid item xs={2} sx={{ textAlign: 'start' }}>
          <Link
            href="#"
            onClick={() =>
              handleLinkClick(
                formatMessage({ id: 'header.greyBox.advisoryServices.url' }),
                formatMessage({ id: 'header.greyBox.advisoryServices.text' }),
                true,
              )
            }
          >
            {formatMessage({ id: 'header.greyBox.advisoryServices.text' })}
          </Link>
        </Grid>
      </Grid>
    </StyledBox>
  );
}
